module.exports = __webpack_public_path__ + "img/banner-cagliari-store.94d1ec68.png";